// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ProspectScreeningService = {};
 
ProspectScreeningService.getProspectScreeningList = function (userInput) {
 
  var userInputIndex = userInput.pageIndex || 0;
 
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
 

  return lossClient({
    url:
      "/inputprospect/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&prospectStep=" +
      userInput.prospectStep +
      "&prospectId=" +
      userInput.prospectScreeningId +
      "&name=" +
      userInput.name +
      "&startDate=" +
      userInput.startDate +
      "&endDate=" +
      userInput.endDate +
      "&branchId=" +
      userInput.branchId,
  });
};

ProspectScreeningService.getProspectPreScreeningList = function (userInput) {
 
  return lossClient({
    url: "/prospectprescreening/screening?prospectid=" + userInput.prospectid,
    method: "get",
  });
};

ProspectScreeningService.getCalculateContract = function (userInput) {
 

  return lossClient({
    url:
      "/InputProspect/calculateendcontract?birthDate=" +
      userInput.birthDate +
      "&tenor=" +
      userInput.tenor,
    method: "get",
  });
};

ProspectScreeningService.getCalculateAge = function (userInput) {
 

  return lossClient({
    url: "/InputProspect/calculatecurrentage?birthDate=" + userInput.birthDate,
    // +
    // "&tenor=" +
    // userInput.tenor,
    method: "get",
  });
};

ProspectScreeningService.processProspectScreening = function (data) {
 

  return lossClient({
    url: "/prospectprescreening/process",
    method: "post",
    data: data,
  });
};

export default ProspectScreeningService;
